
import { defineComponent, ref, watch } from 'vue'
import {
  ElForm,
  ElFormItem,
  ElButton,
  ElInput,
  ElMessageBox,
  ElMessage,
  ElTooltip,
  ElCheckbox,
} from 'element-plus'
import Verify from './verifition/Verify.vue'
import { companyContract } from './verifition/api'
import { $t as langs } from '@/Tool'

export default defineComponent({
  name: 'CompanyContract',
  components: {
    Verify,
    ElInput,
    ElForm,
    ElFormItem,
    ElButton,
    ElMessageBox,
    ElMessage,
    ElTooltip,
    ElCheckbox,
  },
  setup() {
    const contractVisible = ref(false)
    const formRef = ref(null)
    const form = ref({
      mobile: '',
      smsCode: '',
      corpName: '',
      agree: false,
    })
    const subimtAbled = ref(false)
    watch(
      form.value,
      (newVal) => {
        subimtAbled.value = !!newVal.mobile && !!newVal.smsCode && !!newVal.corpName
      },
      { deep: true },
    )

    const countDown = ref(0)
    const verify = ref(null)

    // 手机号验证
    const validatePhone = (rule: any, value: any, callback: any) => {
      const regex = /^(?:(?:\+|00)86)?1\d{10}$/
      if (value === '') {
        callback(new Error(langs('login.form.phone')))
      } else if (!regex.test(value)) {
        callback(new Error(langs('phone.login.rule[3]')))
      } else {
        callback()
      }
    }

    const rules = ref({
      mobile: [
        { required: true, message: '请输入手机号' },
        { validator: validatePhone, trigger: 'blur' },
      ],
      smsCode: [{ required: true, message: '请输入验证码' }],
      corpName: [{ required: true, message: '请输入企业名称' }],
    } as any)

    const showVerify = () => {
      // 校验手机号不能为空
      if (form.value.mobile === '') {
        ElMessage({
          message: langs('login.form.phone'),
          type: 'warning',
        })
        return
      }

      // 校验手机号合法性（使用项目中已有的手机号正则校验）
      const regex = /^(?:(?:\+|00)86)?1\d{10}$/
      if (!regex.test(form.value.mobile)) {
        ElMessage({
          message: langs('phone.login.rule[3]'),
          type: 'error',
        })
        return
      }

      verify.value.show(form.value.mobile)
    }
    const verifySuccess = (params: any) => {
      if (params) {
        countDown.value = 60
        const timer = setInterval(() => {
          countDown.value--
          if (countDown.value === 0) {
            clearInterval(timer)
          }
        }, 1000)
        ElMessage({
          message: langs('phone.login.tips[1]'),
          type: 'success',
        })
      } else {
        ElMessage({
          message: langs('phone.login.tips[2]'),
          type: 'warning',
        })
      }
    }
    const submit = () => {
      if (!form.value.agree) {
        ElMessage({
          message: langs('请勾选公约条款'),
          type: 'warning',
        })
        return
      }
      formRef.value.validate((valid: boolean) => {
        if (valid) {
          companyContract(form.value).then((res) => {
            if (res.success) {
              ElMessage({
                message: '提交成功',
                type: 'success',
              })
              // clearFormData()
            } else {
              ElMessage({
                message: res.message,
                type: 'error',
              })
            }
          })
        }
      })
    }

    // 清空表单数据
    const clearFormData = () => {
      form.value.mobile = ''
      form.value.smsCode = ''
      form.value.corpName = ''
      form.value.agree = false
    }

    const htmlContent = ref(
      window.location.origin + window.location.pathname + 'CompanyContract.html',
    )

    const agree = () => {
      contractVisible.value = false
      form.value.agree = true
    }

    // 处理手机号输入，只允许数字
    const handleMobileInput = (value: string) => {
      form.value.mobile = value.replace(/[^\d]/g, '')
    }

    // 处理验证码输入，只允许数字
    const handleSmsCodeInput = (value: string) => {
      form.value.smsCode = value.replace(/[^\d]/g, '')
    }

    return {
      contractVisible,
      htmlContent,
      form,
      rules,
      formRef,
      showVerify,
      submit,
      agree,
      verify,
      verifySuccess,
      countDown,
      subimtAbled,
      handleMobileInput,
      handleSmsCodeInput,
    }
  },
})
